import store from "@/store";

const EXTENSIONS = ["jpg", "png", "svg"];

/**
 * Tente de charger un logo statique via webpack require.
 * Les images doivent être dans src/assets/media/logos/<maitre_compta>/<variant>.<ext>
 * @param {string} maitreCompta - ID du maître compta.
 * @param {string} variant - "full" ou "collapsed".
 * @returns {string|null} Le chemin résolu ou null.
 */
function getStaticLogo(maitreCompta, variant) {
  return EXTENSIONS.reduce((result, ext) => {
    if (result) return result;
    try {

      return require(`@/assets/media/logos/${maitreCompta}/${variant}.${ext}`);
    } catch {
      // Fichier non trouvé, on essaie l'extension suivante
      return null;
    }
  }, null);
}

/**
 * Vérifie si le marché actuel dispose d'un logo spécifique
 * @returns {boolean}
 */
export function marcheHasLogo() {
  const { organismeActuel, isHorsMarche } = store.getters;

  if (isHorsMarche || !organismeActuel) return false;

  const { maitre_compta: maitreCompta } = organismeActuel;
  if (maitreCompta && getStaticLogo(maitreCompta, "full")) return true;

  return false;
}

/**
 * Retourne le logo du marché à afficher, ou null si hors marché / aucun logo disponible.
 * @param {boolean} collapsed - Si true, retourne la version collapsed (avec fallback sur full).
 * @returns {string|null} Le chemin du logo, ou null pour laisser le logo par défaut.
 */
export function getMainLogo(collapsed = false) {
  const { organismeActuel } = store.getters;

  if (!organismeActuel) return null;

  const { maitre_compta: maitreCompta } = organismeActuel;

  if (maitreCompta) {
    const variant = collapsed ? "collapsed" : "full";
    const logo = getStaticLogo(maitreCompta, variant);
    if (logo) return logo;

    // Si la version collapsed n'existe pas, on se rabat sur full
    if (collapsed) {
      const fullLogo = getStaticLogo(maitreCompta, "full");
      if (fullLogo) return fullLogo;
    }
  }

  // Fallback sur l'image fournie par l'API
  return null;
}
